import React, { useEffect } from 'react';
import { Grid, TextField, Typography, Paper, MenuItem} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

function DatosDesistimiento({ state, onChange, solicitud }) {
    const safeValue = (field) => (state?.[field]?.valor || '');
    const safeError = (field) => (state?.[field]?.error || '');
    const theme = useTheme();

            useEffect(() => {
        
                    if (solicitud?.usuario_registro) {
            
                        const usuario = solicitud.usuario_registro;
            
                        const nombreCompleto = `
                            ${usuario.primer_nombre || ''} 
                            ${usuario.segundo_nombre || ''} 
                            ${usuario.primer_apellido || ''} 
                            ${usuario.segundo_apellido || ''}
                        `.replace(/\s+/g, ' ').trim();
        
                        onChange({
                            target: {
                                name: 'nombre_interesado',
                                value: nombreCompleto
                            }
                        });
            
                        onChange({
                            target: {
                                name: 'documento_interesado',
                                value: usuario.identificacion || ''
                            }
                        });
        
                        onChange({
                            target: {
                                name: 'numero_contacto',
                                value: usuario.celular || usuario.telefono || ''
                            }
                        });
                    }
                }, [solicitud]);

    return (
        <Grid container spacing={3}>

            <Grid item xs={12}>
                <Paper elevation={0} style={{ padding: 15, backgroundColor: '#f9f9f9', borderLeft: `4px solid ${theme.palette.primary.main}`}}>
                    <Typography variant="caption" style={{ textAlign: 'justify', display: 'block' }}>
                        <strong>EL COMITÉ DE BUEN TRATO, Teniendo en consideración que:</strong><br />
                        1. El Acuerdo 2094 de 2022 establece el Protocolo para prevenir y sancionar las violencias basadas en género.
                        2. El Acuerdo dispone que, el Comité de Buen Trato podrá citar a la persona interesada para ampliar la información de la queja y prestar atención psicosocial, de ser el caso.
                        3. La Ruta consigna que, en el eventual caso en que la persona incumpla en tres (3) ocasiones sin causa justificadora, la citación, se procederá a archivar provisionalmente el proceso de atención.
                    </Typography>
                </Paper>
            </Grid>

            <Grid item xs={12} md={3}>
                <TextField
                    select
                    fullWidth
                    label="Calidad del interesado"
                    name="rol_interesado"
                    value={safeValue('rol_interesado')}
                    onChange={onChange}
                    error={!!safeError('rol_interesado')}
                    helperText={safeError('rol_interesado')}
                >
                    <MenuItem value="Estudiante">Estudiante</MenuItem>
                    <MenuItem value="Docente">Docente</MenuItem>
                    <MenuItem value="Colaborador">Colaborador</MenuItem>
                </TextField>
            </Grid>

            <Grid item xs={12} md={3}>
                <TextField
                    disabled
                    fullWidth
                    label="Nombre completo"
                    name="nombre_interesado"
                    value={safeValue('nombre_interesado')}
                    onChange={onChange}
                />
            </Grid>

            <Grid item xs={12} md={3}>
                <TextField
                    disabled
                    fullWidth
                    label="Documento de Identidad"
                    name="documento_interesado"
                    value={safeValue('documento_interesado')}
                    onChange={onChange}
                />
            </Grid>

            <Grid item xs={12} md={3}>
                <TextField
                    fullWidth
                    type="date"
                    label="Fecha última comunicación"
                    name="fecha_ultima_comunicacion"
                    InputLabelProps={{ shrink: true }}
                    value={safeValue('fecha_ultima_comunicacion')}
                    onChange={onChange}
                    error={!!safeError('fecha_ultima_comunicacion')}
                    helperText={safeError('fecha_ultima_comunicacion') || "Fecha desde la cual no se recibe respuesta"}
                />
            </Grid>

            <Grid item xs={12} md={12}>
                <Paper elevation={0} style={{ padding: 15, backgroundColor: '#f9f9f9', borderLeft: `4px solid ${theme.palette.primary.main}`}}>
                    <Typography variant="body2" gutterBottom>
                        Quien había consentido la activación de la Ruta de Atención a Violencias Basadas en Género (VBG), no ha asistido a las reuniones citadas, dado respuesta a los requerimientos o emitido alguna clase de comunicación desde el día <strong>{safeValue('fecha_ultima_comunicacion')}</strong>, por lo que el Comité de Buen Trato procede a CERRAR el caso de cara a los lineamientos del acuerdo 2094 de 2022 y se procede a archivar de forma PROVISIONAL la presente queja.
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                            Se deja constancia de que el procedimiento podrá reabrirse si la persona presuntamente victimizada expresa el consentimiento de su apertura dentro del año subsiguiente a la presentación de la queja. Pasado este tiempo sin comunicación del interesado/a se procederá al cierre definitivo del caso.
                    </Typography>
                </Paper>
            </Grid>

        </Grid>
    );
}

export const FormularioActaArchivoProvisionalSteps = [
    {
        label: 'Datos del Caso',
        render: (props) => <DatosDesistimiento {...props} />
    }
];